import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ContactPage from './ContactPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<ContactPage />);
